import { addTransition } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';

const styledAbsoluteCommon = css`
	position: absolute;
	left: 0;
	right: 0;
	margin: auto;
`;

const styledCommonLine = css`
	${styledAbsoluteCommon}
	content: '';
	width: 100%;
	height: 1px;
	background: linear-gradient(
		90deg,
		rgba(190, 167, 126, 0.03405112044817926) 5%,
		rgba(190, 167, 126, 0.5130427170868348) 52%,
		rgba(190, 167, 126, 0.04245448179271705) 95%
	);
`;

export const StyledChildFirstLine = styled.div`
	&:before {
		top: 7px;
	}
	&:after {
		bottom: 7px;
	}
`;

export const StyledChildrenModal = styled.div`
	position: relative;

	width: 100%;
	height: auto;

	min-height: 100px;

	padding: 40px 0;

	&:before,
	&:after,
	${StyledChildFirstLine}:before, ${StyledChildFirstLine}:after {
		${styledCommonLine}
	}

	&:before {
		top: 0;
	}

	&:after {
		bottom: 0;
	}
`;

export const StyledCenteredLine = styled.div`
	&:before,
	&:after {
		content: ' ';
		position: absolute;

		left: 40%;

		width: 20%;
		height: 2px;

		background-color: ${(p) => p.theme.colors.gold};
	}

	&:before {
		top: -2px;
	}

	&:after {
		bottom: -2px;
	}
`;

export const StyledContentContainer = styled.div<{ isVisible: boolean }>`
	width: 100%;

	${(p) => css`
		${addTransition()}

		${p.isVisible
			? css`
					opacity: 1;
					transform: scale(1);
			  `
			: css`
					opacity: 0;
					transform: scale(0.95);
			  `}
	`}
`;

export const StyledBlurredModal = styled.div<{
	isVisible?: boolean;
	closeModal?: boolean;
}>`
	${(p) => css`
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 900;

		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		${addTransition()}

		${p.isVisible
			? css`
					background-color: rgba(5, 5, 5, 0.75);
					backdrop-filter: blur(10px);
			  `
			: css`
					background-color: transparent;
					backdrop-filter: blur(0);
			  `}

		& .child-animated {
			${addTransition()}
			${p.isVisible ? `opacity: 1;` : `opacity: 0;`}
		}
	`}
`;
